import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

let config = {	
		apiKey: "AIzaSyBt8iZZM5RTfqWhezIYSk0nRqvyMXpZ4Mg",
		authDomain: "hyper-wash.firebaseapp.com",
		projectId: "hyper-wash",
		storageBucket: "hyper-wash.appspot.com",
		messagingSenderId: "628864480299",
		appId: "1:628864480299:web:4815ed41f95a205375a66e",
		measurementId: "G-WRJC2L62JR",
		databaseURL: ""
  };

  export default !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();
  export const db =  !firebase.apps.length ? firebase.initializeApp(config) : firebase.firestore();
  export const firestorage =  !firebase.apps.length ? firebase.initializeApp(config) : firebase.storage();
  export const firestore = !firebase.apps.length ? firebase.initializeApp(config) : firebase.firestore();
  export const firestoreHelpers = !firebase.apps.length ? firebase.initializeApp(config) : firebase.firestore;
  export const functions = !firebase.apps.length ? firebase.initializeApp(config) : firebase.app().functions('europe-west3');